import { useCallback } from 'react';

import { useHandleCommonError } from '@wwe-portal/web/utils/error-handler/error';
import { OfferData } from '@wwe-portal/entities/offer.type';
import { PaymentContext } from '@wwe-portal/web/providers/stores/payment-store';
import { useHandleXsollaPayment } from './use-handle-xsolla-payment';
import { sendPurchaseFailedEvent } from '@wwe-portal/web/libs/analytics/offer';

export const useNotifyPaymentError = () => {
  const handleCommonError = useHandleCommonError();
  const handleXsollaPayment = useHandleXsollaPayment();
  return useCallback(
    (
      { offerData, context }: { offerData: OfferData; context: PaymentContext },
      error: unknown
    ) => {
      const { isHandled, isCancelled } = handleXsollaPayment(error);
      // If a payment fails because the user actively cancels it, we do not send any analytics events.
      if (offerData && !isCancelled)
        sendPurchaseFailedEvent(offerData, context, error as Error);
      if (!isHandled) handleCommonError(error);
    },
    [handleCommonError, handleXsollaPayment]
  );
};
